import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectLMSCollectionsQueryItems } from '../../../../../redux/lms/collections/selector';
import { lmsCollections } from '../../../../../redux/lms/collections/action';
import PageLoader from '../../../../../components/PageLoader';
import CollectionComponent from '../components/collection.component';

const ManagementLMSCollection = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const lmsCollectionsQuery = useSelector(selectLMSCollectionsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectLMSCollections, setSelectLMSCollections] = useState<any>(
    {
      "title": "",
      "description": "",
      "mappedTopics": {
        "mappedTopicIds": []
      },
      "mediaMappings": {
        "mediaFiles": [],
        "templates": []
      }
    }
  );

  const fetchLMSCollectionsQueryById = () => {
    dispatch(lmsCollections.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections/query`,
      entity: 'lmsCollections',
      jsonData: {
        records: [
          {
            id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSCollections({ ...selectLMSCollections, [field]: event })
  }

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchLMSCollectionsQueryById()
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectLMSCollections(lmsCollectionsQuery?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(lmsCollections.resetAction({ actionType: 'update' }))
      await dispatch(lmsCollections.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections`,
        entity: 'lmsCollections',
        jsonData: {
          records: [
            selectLMSCollections
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(lmsCollections.resetAction({ actionType: 'create' }))
      await dispatch(lmsCollections.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections`,
        entity: 'lmsCollections',
        jsonData: {
          records: [
            selectLMSCollections
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/collections')
  }

  return (
    <>
      {lmsCollectionsQuery?.isLoading ? <PageLoader /> :
        <CollectionComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSCollections={selectLMSCollections}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
}

export default ManagementLMSCollection;